import ExportButton from 'components/ExportButton/ExportButton.js'
import {
  DateFormat,
  filterData,
} from 'modules/Reports/Components/CommonFunction/CommonFunctionIndex'
import CorporateInfoTable from 'modules/Reports/Partials/Corporates/Partials/CorporateInfoTable'
import {
  PaddedDiv,
  SectionWrapper,
  TopHeader,
  TopHeading,
} from 'modules/Reports/Styles/style.js'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import WarningMessage from 'utils/WarningMessage'
import {
  setCityList,
  setCorporateListForReport,
  setIndustryList,
  setSectorList,
  setSingleIndustryData,
  setSingleSectorData,
  setStateList,
} from '../../../../actions'
import { industrySectorPart } from '../../../Students/Partials/Function/Function'

const EmpanelledInfoTable = ({
  getCorporateListForReport,
  corporateListDataForReport,
  getSectorList,
  sectorList,
  getCityList,
  getIndustryList,
  getStateList,
  industryList,
  cityList,
  stateList,
  excelDataForReport,
  IndustrySectorUrl,
  industrySectorData,

  getSingleSectorList,
  singleSectorData,
  singleIndustryData,
  getSingleIndustryList,

  getUserInfo,
  userData,
}) => {
  const dispatch = useDispatch()
  const [page, setPage] = useState(0)
  const [count, setCount] = useState(0)
  const [loadingDep, setLoadingDep] = useState(false)
  const [tooltip, setToolTip] = useState(false)
  const [searchDegree, setSearchDegree] = useState('')
  const [keyDegree, setKeyDegree] = useState('')
  const [degreeList, setDegreeList] = useState([])
  const [searchQuery, setSearchQuery] = useState('')
  const [degreeListData, setDegreeListData] = useState([])
  const [degreeLoader, setDegreeLoader] = useState(false)
  const [debouncedDegree, setDebouncedDegree] = useState(() => keyDegree)
  const [sortBy, setSortBy] = useState('')
  const [pageNum, setPageNum] = useState(1)
  const [filterDatas, setFilterData] = useState({})
  const [keySector, setKeySector] = useState('')
  const [searchValue, setSearchValue] = useState('')
  const [debouncedSearch, setDebouncedSearch] = useState(() => searchValue)
  const [stateCount, setStateCount] = useState(0)
  const [stateData, setStateData] = useState([])
  const [cityCount, setCityCount] = useState(0)
  const [cityPage, setCityPage] = useState(0)
  const [cityData, setCityData] = useState([])
  const [statePage, setStatePage] = useState(0)
  const [first, setFirst] = useState(true)
  const [sectorLoading, setSectorLoading] = useState(false)
  const [stateLoading, setStateLoading] = useState(false)
  const [loading, setLoading] = useState(false)
  const [loadingCity, setLoadingCity] = useState(false)
  const [loadingCorp, setLoadingCorp] = useState(false)
  const [sectorValue, setSectorValue] = useState([])
  const [stateValue, setStateValue] = useState([])
  const [cityValue, setCityValue] = useState([])
  const [industryValue, setIndustryValue] = useState([])
  const [keyState, setKeyState] = useState('')
  const [keyCity, setKeyCity] = useState('')
  const [keyIndustry, setKeyIndustry] = useState('')
  const [createdAtStart, setCreatedAtStart] = useState('')
  const [createdAtEnd, setCreatedAtEnd] = useState('')
  const [debounced, setDebounced] = useState(() => keySector)
  const [debouncedIndustry, setDebouncedIndustry] = useState(() => keyIndustry)
  const [debouncedCity, setDebouncedCity] = useState(() => keyCity)
  const [debouncedState, setDebouncedState] = useState(() => keyState)
  const [clearDate, setClearDate] = useState(false)
  const [previousPage, setPreviousPage] = useState('')
  const [keySingleSector, setKeySingleSector] = useState('')
  const [debouncedSingleSectorSearch, setDebouncedSingleSearch] = useState(
    () => keySingleSector
  )
  const [singleSectorLoading, setSingleSectorLoading] = useState(false)
  const [singleSectorValue, setSingleSectorValue] = useState([])
  const [singleSectorCount, setSingleSectorCount] = useState(0)
  const [singleSectorPage, setSingleSectorPage] = useState(0)
  const [singleSectorDataFinal, setSingleSectorDataFinal] = useState([])
  const [keySingleIndustry, setKeySingleIndustry] = useState('')
  const [debouncedSingleIndustrySearch, setDebouncedSingleIndustrySearch] =
    useState(() => keySingleIndustry)
  const [singleIndustryLoading, setSingleIndustryLoading] = useState(false)
  const [singleIndustryValue, setSingleIndustryValue] = useState([])
  const [singleIndustryCount, setSingleIndustryCount] = useState(0)
  const [singleIndustryPage, setSingleIndustryPage] = useState(0)
  const [singleIndustryDataFinal, setSingleIndustryDataFinal] = useState([])
  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedSingleIndustrySearch(keySingleIndustry)
    }, 500)
    return () => {
      clearTimeout(timeout)
    }
  }, [keySingleIndustry])
  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedSingleSearch(keySingleSector)
    }, 500)
    return () => {
      clearTimeout(timeout)
    }
  }, [keySingleSector])
  useEffect(() => {
    dispatch(setSingleIndustryData([]))
    let flag = 'LC'
    let page = 0
    setSingleIndustryPage(0)
    getSingleIndustryList({
      setSingleIndustryLoading,
      keySingleIndustry,
      flag,
      page,
    })
  }, [debouncedSingleIndustrySearch])
  useEffect(() => {
    dispatch(setSingleSectorData([]))
    let flag = 'LC'
    let page = 0
    setSingleSectorPage(0)
    getSingleSectorList({
      setSingleSectorLoading,
      keySingleSector,
      flag,
      page,
    })
  }, [debouncedSingleSectorSearch])
  const loadMoreSingleSectorData = async () => {
    let flag = 'LC'
    let page = singleSectorData?.page + 1
    getSingleSectorList({
      setSingleSectorLoading,
      keySingleSector,
      flag,
      page,
    })

    setSingleSectorPage(singleSectorPage + 1)
  }
  const loadMoreSingleIndustryData = async () => {
    let flag = 'LC'
    let page = singleIndustryData?.page + 1
    getSingleIndustryList({
      setSingleIndustryLoading,
      keySingleIndustry,
      flag,
      page,
    })

    setSingleIndustryPage(singleIndustryPage + 1)
  }

  //User Call
  useEffect(() => {
    getUserInfo()
  }, [])

  function hasData(obj) {
    for (let key in obj) {
      // eslint-disable-next-line no-prototype-builtins
      if (obj.hasOwnProperty(key) && obj[key] !== '') {
        return true
      }
    }
    return false
  }
  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedDegree(searchDegree)
    }, 1000)
    return () => {
      clearTimeout(timeout)
    }
  }, [searchDegree])
  useEffect(() => {
    dispatch(setCorporateListForReport([]))

    if (hasData(filterDatas)) {
      setFirst(false)
      getCorporateListForReport({
        pageSize: 10,
        pageNumber: 0,
        setLoadingCorp,
        searchValue,
        filterDatas,
        sortBy,
      })
      setPageNum(1)
    }
  }, [debouncedSearch, filterDatas, sortBy])

  useEffect(() => {
    dispatch(setCorporateListForReport([]))

    if (hasData(filterDatas)) {
      if (pageNum) {
        getCorporateListForReport({
          pageSize: 10,
          pageNumber: pageNum - 1,
          setLoadingCorp,
          searchValue,
          filterDatas,
          sortBy,
        })
      }
    }
  }, [pageNum])
  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebounced(keySector)
    }, 500)
    return () => {
      clearTimeout(timeout)
    }
  }, [keySector])

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedSearch(searchValue)
    }, 1000)
    return () => {
      clearTimeout(timeout)
    }
  }, [searchValue])

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedState(keyState)
    }, 500)
    return () => {
      clearTimeout(timeout)
    }
  }, [keyState])
  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedCity(keyCity)
    }, 500)
    return () => {
      clearTimeout(timeout)
    }
  }, [keyCity])

  useEffect(() => {
    dispatch(setCityList([]))
    let flag = 'LC'
    let page = 0
    getCityList({ setLoadingCity, keyCity, flag, page })
  }, [debouncedCity])

  useEffect(() => {
    dispatch(setStateList([]))
    let flag = 'LC'
    let page = 0
    setStatePage(0)
    getStateList({ setStateLoading, keyState, flag, page })
  }, [debouncedState])

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedIndustry(keyIndustry)
    }, 500)
    return () => {
      clearTimeout(timeout)
    }
  }, [keyIndustry])

  useEffect(() => {
    dispatch(setSectorList([]))
    let flag = 'LC'
    getSectorList({ setSectorLoading, keySector, flag })
  }, [debounced])

  useEffect(() => {
    dispatch(setIndustryList([]))
    let flag = 'LC'

    getIndustryList({ setLoading, keyIndustry, flag })
  }, [debouncedIndustry])

  const title = [
    { title: 'ID' },
    {
      title: 'Corporate Name',
      width: { wch: 40 },
      padding: { ppx: 100 },
      height: { wpx: 22 },
    },
    { title: 'Industry', width: { wch: 40 }, padding: { ppx: 100 } },
    { title: 'Empanelled', width: { wch: 30 } },
    { title: 'Location', width: { wch: 10 }, padding: { ppx: 100 } },
    { title: 'Address', width: { wch: 30 }, padding: { ppx: 100 } },
    { title: 'Contact Person', width: { wch: 45 } },
    { title: 'Email Id', width: { wch: 20 } },
    { title: 'Contact Number', width: { wch: 12 } },
    // { title: 'Location', width: { wch: 10 }, padding: { ppx: 100 } },
    // { title: 'Address', width: { wch: 30 }, padding: { ppx: 100 } },
  ]

  const tableData = excelDataForReport?.result?.map(item => [
    { value: item.prefix_id ? item.prefix_id : '-' },
    {
      value: item.name ? item.name : '-',
    },
    { value: item.industry ? item.industry : '-' },
    { value: DateFormat(item.createdAt) ? DateFormat(item.createdAt) : '-' },
    { value: item.city ? item.city : '-' },
    {
      value:
        (item?.addressLine1 ? item?.addressLine1 + ',' : '') +
        (item?.addressLine2 ? item.addressLine2 + ',' : '') +
        (item?.city ? item.city + ',' : '') +
        (item?.state ? item.state + ',' : '') +
        (item?.country ? item.country : ''),
    },
    { value: item.contactPerson ? item.contactPerson : '-' },
    { value: item.contactEmail ? item.contactEmail : '-' },
    { value: item.contactNumber ? item.contactNumber : '-' },
    // { value: item.city ? item.city : '-' },
    // {
    //   value:
    //     (item?.addressLine1 ? item?.addressLine1 + ',' : '') +
    //     (item?.addressLine2 ? item.addressLine2 + ',' : '') +
    //     (item?.city ? item.city + ',' : '') +
    //     (item?.state ? item.state + ',' : '') +
    //     (item?.country ? item.country : ''),
    // },
  ])

  const excelData = [{ columns: title, data: tableData }]
  const [isExcel, setIsExcel] = useState('')
  const [excel, setExcel] = useState([])

  const clickedExcel = data => {
    let excel = true
    getCorporateListForReport({
      pageSize: 5000,
      pageNumber: 0,
      setLoading,
      searchValue,
      filterDatas,
      sortBy,
      excel,
    })
    setIsExcel(data)
  }
  useEffect(() => {
    if (
      (excelDataForReport?.result && tableData && isExcel == 'excel') ||
      (excelDataForReport?.result && tableData && isExcel == 'pdf')
    ) {
      if (loadingCorp) {
        setExcel([])
      } else {
        setExcel(excelData)
      }
    }
  }, [excelDataForReport?.result, loadingCorp])
  const handleHover = () => {
    if (corporateListDataForReport?.count > 5000) {
      WarningMessage(
        'Note : The student count should not exceed 5,000 for data export.  Apply filters if necessary'
      )
    }
  }
  useEffect(() => {
    let flag = 'LC'
    setDegreeList([])
    setPage(0)
    IndustrySectorUrl(flag, setLoadingDep, searchDegree, 0, setDegreeLoader)
  }, [debouncedDegree])
  const handleSearch = e => {
    const query = e.target.value
    setSearchQuery(query)
  }

  useEffect(() => {
    const updatedData = industrySectorPart({
      listOfDegree: industrySectorData?.result,
      selectedIds: [],
      isEditActiveRole: [],
      childValueParam: 'sectorindustryid',
      childNameParam: 'industry',
      parentNameParam: 'sector',
      parentValueParam: 'sector_id',
      pathName: 'industry',
    })
    setCount(industrySectorData?.count)
    setPage(industrySectorData?.page)
    setDegreeListData(updatedData)
  }, [industrySectorData])
  const loadMoreData = async () => {
    let flag = 'LC'
    IndustrySectorUrl(
      flag,
      setLoadingDep,
      searchDegree,
      industrySectorData?.page + 1,
      setDegreeLoader
    )
    setPage(page + 1)
  }
  const loadMoreStateData = async () => {
    let flag = 'LC'
    let page = stateList?.page + 1
    getStateList({ setStateLoading, keyState, flag, page })

    setStatePage(statePage + 1)
  }
  const loadMoreCityData = async () => {
    let flag = 'LC'
    let page = cityList?.page + 1
    getCityList({ setLoadingCity, keyCity, flag, page })

    setCityPage(page + 1)
  }

  useEffect(() => {
    if (stateList) {
      setStateCount(stateList?.count)
      let data = filterData(stateList?.result, 'state')
      setStateData(data)
    }
    if (cityList) {
      setCityCount(cityList?.count)
      let data = filterData(cityList?.result, 'city')
      setCityData(data)
    }

    if (singleSectorData) {
      setSingleSectorCount(singleSectorData?.count)
      let data = filterData(singleSectorData?.result, 'sector')
      setSingleSectorDataFinal(data)
    }
    if (singleIndustryData) {
      setSingleIndustryCount(singleIndustryData?.count)
      let data = filterData(singleIndustryData?.result, 'industry')
      setSingleIndustryDataFinal(data)
    }
  }, [stateList, cityList, singleSectorData, singleIndustryData])

  // const columnWidths = [17, 40, 35, 24, 26, 38, 35, 42, 30]// Array of column widths
  const columnWidths = [17, 46, 37, 23, 24, 38, 35, 42, 25] // Array of column widths
  // const columnWidths=[17, 35, 28, 28, 30, 38, 35, 42,35]// Array of column widths

  const HAlign = [
    'left',
    'left',
    'left',
    'left',
    'left',
    'left',
    'left',
    'left',
    'left',
  ]

  return (
    <SectionWrapper column>
      <PaddedDiv column>
        <TopHeader row spaceBetween alignCenter>
          <TopHeading flexStart>List of Corp. Empanelled</TopHeading>
          <TopHeading flexEnd style={{ display: 'flex', gap: 10 }}>
            <div role="button" tabIndex="0" onMouseEnter={handleHover}>
              <ExportButton
                dataset={excel}
                title={'List of Corp. Empanelled'}
                loading={loading}
                clickedExcel={clickedExcel}
                data={isExcel}
                setIsExcel={setIsExcel}
                count={corporateListDataForReport?.count || 0}
                columnWidth={columnWidths} // Array of column widths
                columnFontSize={10} // Font size for the column data
                horizontalAlignment={HAlign}
                userData={userData}
              />
            </div>
          </TopHeading>
        </TopHeader>
      </PaddedDiv>
      <CorporateInfoTable
        singleIndustryPage={singleIndustryPage}
        setSingleIndustryPage={setSingleIndustryPage}
        singleIndustryDataFinal={singleIndustryDataFinal}
        singleIndustryCount={singleIndustryCount}
        loadMoreSingleIndustryData={loadMoreSingleIndustryData}
        singleIndustryData={filterData(singleIndustryData?.result, 'industry')}
        singleIndustryValue={singleIndustryValue}
        setSingleIndustryValue={setSingleIndustryValue}
        keySingleIndustry={keySingleIndustry}
        singleIndustryLoading={singleIndustryLoading}
        setKeySingleIndustry={setKeySingleIndustry}
        singleSectorPage={singleSectorPage}
        setSingleSectorPage={setSingleSectorPage}
        singleSectorDataFinal={singleSectorDataFinal}
        singleSectorCount={singleSectorCount}
        loadMoreSingleSectorData={loadMoreSingleSectorData}
        singleSectorData={filterData(singleSectorData?.result, 'sector')}
        singleSectorValue={singleSectorValue}
        setSingleSectorValue={setSingleSectorValue}
        keySingleSector={keySingleSector}
        singleSectorLoading={singleSectorLoading}
        setKeySingleSector={setKeySingleSector}
        cityCount={cityCount}
        stateCount={stateCount}
        cityPage={cityPage}
        statePage={statePage}
        loadMoreCityData={loadMoreCityData}
        loadMoreStateData={loadMoreStateData}
        setDegreeList={setDegreeList}
        setKeyDegree={setKeyDegree}
        handleSearch={handleSearch}
        searchQuery={searchQuery}
        degreeList={degreeList}
        setSearchDegree={setSearchDegree}
        degreeListData={degreeListData}
        setSearchQuery={setSearchQuery}
        setDegreeLoader={setDegreeLoader}
        degreeLoader={degreeLoader}
        sectorLoading={sectorLoading}
        stateLoading={stateLoading}
        setSectorLoading={setSectorLoading}
        setStateLoading={setStateLoading}
        hasProp={hasData(filterDatas)}
        loadingCorp={loadingCorp}
        setLoadingCity={setLoadingCity}
        loadingCity={loadingCity}
        loading={loading}
        setSortBy={setSortBy}
        setSearchValue={setSearchValue}
        searchValue={searchValue}
        tableData={first ? [] : corporateListDataForReport}
        sectorList={filterData(sectorList?.result, 'sector')}
        industryList={filterData(industryList?.result, 'industry')}
        cityList={cityData}
        stateList={stateData}
        sectorValue={sectorValue}
        setSectorValue={setSectorValue}
        setFilterData={setFilterData}
        filterData={filterDatas}
        stateValue={stateValue}
        cityValue={cityValue}
        industryValue={industryValue}
        setStateValue={setStateValue}
        setCityValue={setCityValue}
        setIndustryValue={setIndustryValue}
        setKeySector={setKeySector}
        keySector={keySector}
        keyState={keyState}
        keyIndustry={keyIndustry}
        keyCity={keyCity}
        setKeyCity={setKeyCity}
        setKeyIndustry={setKeyIndustry}
        setKeyState={setKeyState}
        isEmpanelled={true}
        createdAtStart={createdAtStart}
        createdAtEnd={createdAtEnd}
        setCreatedAtStart={setCreatedAtStart}
        setCreatedAtEnd={setCreatedAtEnd}
        setPageNum={setPageNum}
        pageNum={pageNum}
        setToolTip={setToolTip}
        tooltip={tooltip}
        setClearDate={setClearDate}
        clearDate={clearDate}
        setPreviousPage={setPreviousPage}
        previousPage={previousPage}
        loadingDep={loadingDep}
        page={page}
        count={count}
        loadMoreData={loadMoreData}
        getStateList={getStateList}
        getSectorList={getSectorList}
        getCityList={getCityList}
        getSingleIndustryList={getSingleIndustryList}
        getSingleSectorList={getSingleSectorList}
      />
    </SectionWrapper>
  )
}
export default EmpanelledInfoTable
